export const Dropdown = {};

export const CustomDropdown = {
	dropdownPaddingTopBottom: 'var(--epods--padding-topBottom-dropdown)',
	dropdownPaddingLeft: 'var(--epods--padding-left-dropdown)',
	dropdownHeight: 'var(--epods--height-dropdown)',
	dropdrownTextSize: 'var(--epods--dropdrown_text-size)',
	dropdrownTextHeight: 'var(--epods--dropdrown_text-height)',
	dropdrownTextColor: 'var(--epods--dropdrown_text-color)',
};
